// extracted by mini-css-extract-plugin
export default {"giftVouchers":"GiftVouchers_giftVouchers__92L-k","header":"GiftVouchers_header__VpiTK","footer":"GiftVouchers_footer__GSVrW"};